<div class="attendance-wrapper">

     <div class="month-selector">
    <button mat-icon-button (click)="previousMonth()">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <span class="month-label">{{ currentMonthLabel() }}</span>

    <button mat-icon-button (click)="nextMonth()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <div class="legend">
  <span><mat-icon color="primary" class="CHECKED_IN">alarm_on</mat-icon> On Time</span>
  <span><mat-icon color="warn"  class="NO_CHECKIN">cancel</mat-icon> No Check-in</span>
    <span><mat-icon color="warn"  class="YELLOW_TIME">replay_10</mat-icon>< 10 Min</span>
    <span><mat-icon color="warn"  class="ORANGE_TIME">schedule</mat-icon>< 5 Min</span>
    <span><mat-icon color="warn"  class="LATE">error</mat-icon>Late</span>
  <span><mat-icon color="accent" class="TIMEOFF_APPROVED">event_busy</mat-icon> Time Off</span>

  </div>

  <div class="table-container">
    <cdk-virtual-scroll-viewport itemSize="48" class="viewport">

      <table mat-table [dataSource]="employees" class="mat-elevation-z1">

        <ng-container matColumnDef="teacher">
          <th mat-header-cell *matHeaderCellDef sticky>Employee</th>
          <td mat-cell *matCellDef="let emp" sticky class="teacher-cell">
            {{ emp.name }}
          </td>
        </ng-container>

        @for (d of daysInMonth; track d) {
          <ng-container [matColumnDef]="formatDateKey(d)">

            <th mat-header-cell *matHeaderCellDef>
              {{ d.getDate() }}<br>
              <small>{{ d | date:'EEE' }}</small>
            </th>

            <td mat-cell *matCellDef="let emp">
              <div class="day-checkins" (click)="openDetail(emp, d)">

                @for (item of getDayCheckins(emp, d); track $index) {

                             @switch (item.status) {
                          @case ('CHECKED_IN') {
                             <mat-icon color="primary" class="CHECKED_IN">alarm_on</mat-icon>
                          }
                          @case ('EARLY') {
                             <mat-icon color="primary" class="CHECKED_IN">alarm_on</mat-icon>
                          }
                          @case ('NO_CHECKIN') {
                             <mat-icon color="warn"  class="NO_CHECKIN">cancel</mat-icon>
                          }
                        @case ('YELLOW_TIME') {
                              <mat-icon color="accent" class="YELLOW_TIME">replay_10</mat-icon>
                        }
                        @case ('LATE') {
                              <mat-icon color="accent" class="LATE">error</mat-icon>
                        }
                        @case ('ORANGE_TIME') {
                              <mat-icon color="accent" class="ORANGE_TIME">schedule</mat-icon>
                        }
                         @case ('TIMEOFF_APPROVED') {
                             <mat-icon color="warn"  class="TIMEOFF_APPROVED">event_busy</mat-icon>
                          }
                        @case ('CHECKIN_AND_TIMEOFF') {
                             <mat-icon color="warn"  class="NO_CHECKIN">cancel</mat-icon>
                          }
                          @default {
                     <span
                    class="checkin-dot"
                    [ngClass]="item.status"
                    [matTooltip]="getTooltip(item)">
                  </span>
                          }
                        }
                }

                @if (getDayCheckins(emp, d).length === 0) {
                  <mat-icon class="NO_SCHEDULE">remove</mat-icon>
                }

              </div>
            </td>

          </ng-container>
        }


        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

    </cdk-virtual-scroll-viewport>
  </div>
</div>

<!-- MODAL -->
<!-- MODAL -->
<ng-template #attendanceDetailTpl>
  <h2 mat-dialog-title>
    {{ modalTitle }}
  </h2>

  <div mat-dialog-content>

    <p><strong>Employee:</strong> {{ modalEmployeeName }}</p>
    <p><strong>Date:</strong> {{ modalDate | date:'fullDate' }}</p>

    <div class="modal-divider"></div>

    @if (modalTimeOff) {
      <h3>Time Off</h3>

      <p><strong>Status:</strong> Approved</p>
      <p><strong>Type:</strong> {{ modalTimeOff.tipodetimeoff }}</p>

      @if (modalTimeOff.tipodetimeoff === 'Otro') {
        <p><strong>Other:</strong> {{ modalTimeOff.other_timeoff }}</p>
      }

      <p>
        <strong>Payroll:</strong>
        <span [ngClass]="modalTimeOff.paid === 1 ? 'ok' : 'warn'">
          {{ modalTimeOff.paid === 1 ? 'No descuento' : 'Descuento' }}
        </span>
      </p>

      <div class="modal-divider"></div>
    }

    <h3>Check-ins</h3>

    @if (modalCheckins.length > 0) {
      @for (item of modalCheckins; track item.shift_start) {
        <div
          class="modal-checkin-card"
          [ngClass]="item.status"
          (click)="selectCheckinForMap(item)">

          <p><strong>Schedule:</strong> {{ item.shift_start }}</p>

          @if (item.checkintime) {
            <p><strong>Check-in:</strong> {{ item.checkintime }}</p>
            <p><strong>Status:</strong> {{ labelForStatus(item.status) }}</p>

            @if (item.sucursal) {
              <p><strong>Sucursal:</strong> {{ item.sucursal }}</p>
            }

            @if (item.geofence) {
              <p><strong>Geofence:</strong> {{ item.geofence }}</p>
            }

            @if (item.accuracy) {
              <p><strong>Accuracy:</strong> {{ item.accuracy }} m</p>
            }

            @if (item.comment) {
              <p><strong>Comment:</strong> {{ item.comment }}</p>
            }

            @if (item.lat && item.lng) {
              <small class="map-hint">Click this card to view location on map</small>
            }

          } @else {
            <p><strong>Status:</strong> Pending Check-In</p>
          }

        </div>
      }

      @if (selectedMapCheckin?.lat && selectedMapCheckin?.lng) {
        <div class="modal-divider"></div>

        <h3>Check-in Location</h3>
        <p><strong>Selected:</strong> {{ selectedMapCheckin?.shift_start }} / {{ selectedMapCheckin?.checkintime }}</p>

        <div id="leafletMap" class="leaflet-map"></div>
      }

    } @else {
      <p class="muted">No scheduled check-ins for this day.</p>
    }

  </div>

  <div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </div>
</ng-template>

